"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Click here to expand the group members": "Нажмите, чтобы раскрыть список участников группы",
  "Click here to view the group members": "Нажмите, чтобы просмотреть список участников группы",
  "Company, {company}": ["Компания, ", ["company"]],
  "Contact card, {name}": ["Контактная информация, ", ["name"]],
  "Department, {department}": ["Отдел, ", ["department"]],
  "Email, {emailAddress}": ["Адрес электронной почты, ", ["emailAddress"]],
  "Expand members": "Раскрыть список участников",
  "Group - {members, plural, one {# member} other {# members}}": ["Группа — ", ["members", "plural", {
    one: ["#", " участник"],
    other: ["участников: ", "#"]
  }]],
  "Mobile phone, {mobilePhone}": ["Номер мобильного телефона, ", ["mobilePhone"]],
  "Mobile: {mobilePhone}": ["Мобильный телефон: ", ["mobilePhone"]],
  "Name, {name}": ["Имя, ", ["name"]],
  "Title, {title}": ["Должность, ", ["title"]],
  "Type to search": "Введите поисковый запрос",
  "View members": "Просмотреть список участников",
  "Work phone, {workPhone}": ["Номер рабочего телефона, ", ["workPhone"]],
  "Work: {workPhone}": ["Рабочий телефон: ", ["workPhone"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map